<template>
  <router-view />
</template>

<script>
export default {
  name: "StatisticsIndex"
};
</script>

<style scoped>

</style>
